module.exports = __webpack_public_path__ + "img/little_balls_banner_rewards.15072c07.svg";